module.exports = __webpack_public_path__ + "static/media/banner-french-recruiting@1x.b396cddf.png";